import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  orderBy,
  query,
  writeBatch,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './firebase';

const EXPERIENCES_COLLECTION = 'experiences';

export const experiencesService = {
  async getAllExperiences() {
    try {
      const q = query(collection(db, EXPERIENCES_COLLECTION), orderBy('sortOrder', 'asc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch {
      // fallback if sortOrder index not ready
      const q = query(collection(db, EXPERIENCES_COLLECTION), orderBy('createdAt', 'asc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    }
  },

  async getExperienceById(id) {
    const docRef = doc(db, EXPERIENCES_COLLECTION, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) return { id: docSnap.id, ...docSnap.data() };
    throw new Error('Experience not found');
  },

  async createExperience(data) {
    const docRef = await addDoc(collection(db, EXPERIENCES_COLLECTION), {
      ...data,
      sortOrder: data.sortOrder ?? 999,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return docRef.id;
  },

  async updateExperience(id, data) {
    const docRef = doc(db, EXPERIENCES_COLLECTION, id);
    await updateDoc(docRef, { ...data, updatedAt: serverTimestamp() });
  },

  async deleteExperience(id) {
    await deleteDoc(doc(db, EXPERIENCES_COLLECTION, id));
  },

  async updateExperiencesOrder(orderedIds) {
    const batch = writeBatch(db);
    orderedIds.forEach((id, index) => {
      batch.update(doc(db, EXPERIENCES_COLLECTION, id), {
        sortOrder: index,
        updatedAt: serverTimestamp()
      });
    });
    await batch.commit();
  }
};
